import HorizontalDivider from "src/components/HorizontalDivider/HorizontalDivider";
import PaymentBackButton from "./PaymentBackButton";
import { ReactComponent as SuccessIcon } from "src/assets/icons/payment-success.svg";
import "./payment.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const PaymentSuccess = () => {
  const location = useLocation();
  const { t } = useTranslation(["invoice"]);

  const [referenceNo, setReferenceNo] = useState("");
  const paymentDetails = useSelector(
    (state: any) => state.lookup?.paymentDetails
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const referenceNo = searchParams.get("referenceNo");
    if (referenceNo) {
      setReferenceNo(referenceNo);
    }
  }, [location.search]);

  return (
    <div className="d-flex flex-column gap-2 p-4 payment-success">
      <div className="payment-content">
        <div className="top-content d-flex flex-column justify-content-center align-items-center w-100">
          <SuccessIcon className="payment-top-icon" />
          <h5>{t("paymentSuccessful")}</h5>
          <div className="mb-3 d-flex gap-1">
            <span>{t("referenceNo")}</span>
            <span>{referenceNo}</span>
          </div>
        </div>
        <HorizontalDivider />
        <div className="bottom-content d-flex flex-column justify-content-center align-items-center w-100">
          <div className="my-3 d-flex gap-2">
            <span className="font-weight-700">{t("amountPaid")}:</span>
            <span>{paymentDetails?.paidAmount} {t("AED")}</span>
          </div>
          <div className="mb-3 d-flex gap-2">
            <span className="font-weight-700">{t("dateAndTime")}:</span>
            <span>{paymentDetails.paymentDateAndTime}</span>
          </div>
        </div>
        <PaymentBackButton />
      </div>
    </div>
  );
};

export default PaymentSuccess;
